import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette }) => ({
  root: {
    margin: "20px 0",
  },
  paginationButton: {
    borderRadius: 2,
    border: `1px solid ${palette.grey[300]}`,
    backgroundColor: palette.grey[100],
    padding: 9,
    margin: "0 4px",
  },
  tableBody: {
    boxShadow: `0px 5px 5px ${palette.grey[300]}`,
  },
  paginationButtonDisabled: {
    backgroundColor: `${palette.grey[50]} !important`,
  },
  paginationLabel: {
    margin: 0,
  },
}));

export default useStyles;
